import { useEffect, useState } from "react";
import DialogInfoGeneral from "./DialogInfoGeneral";
import { FaChrome, FaEdge, FaFirefox, FaOpera, FaSafari } from "react-icons/fa";

const  SafariAlert = ()  => {
  const [showS, setShow] = useState(false)
  useEffect(() => {
    // Detectar si el navegador es Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      setShow(true)
    }
  }, []); // El array vacío asegura que el efecto se ejecute solo una vez al montar el componente

  return (
    <>
    <DialogInfoGeneral
      show={showS}
      disabledClosable={true}
      disabledFooter={true}
      closeDialog={() => null}
    >
      <div className="text-center py-10 px-6 opensans">
        <div className="text-2xl py-6">
          Parece que estás usando Safari.
          <div className="flex items-center justify-center my-4">
            <FaSafari className="text-green-admin-light" size={37} />

          </div>
        </div>
        <div className="text-lg font-bold">
          Para una mejor experiencia, te recomendamos utilizar.
          <div>
          Chrome, Firefox, Edge.
          <div className="flex items-center justify-center gap-2 mt-6 py-4">
          <FaChrome size={40} className="text-green-admin-dark" />
          <FaFirefox size={40} className="text-green-admin-dark" />
          <FaEdge size={40} className="text-green-admin-dark" />
          <FaOpera size={40} className="text-green-admin-dark" />

          </div>
          </div>
        </div>
      </div>
    </DialogInfoGeneral>
    </>
  );
}

export default SafariAlert;
